<template>
  <div class="main">
    <div class="app-head">
      <div class="app-head-inner">
        <router-link :to="{ path: '/' }">
          <img src="../assets/logo.png" />
        </router-link>
        <div class="member" v-if="Token != null" @click="goUser">
          <i class="el-icon-user-solid"></i>
          <p>{{ GuestCName }}</p>
        </div>
        <div class="head-nav Regular" v-else>
          <router-link tag="div" class="login" to="/login"
            >会员登陆</router-link
          >
          <router-link tag="div" class="add-member" to="/register"
            >加入会员</router-link
          >
        </div>
      </div>
    </div>
    <div class="nav Regular">
      <ul class="nav-list">
        <router-link :to="{ path: '/' }" tag="li" active-class="active">
          客房预订
        </router-link>
      </ul>
    </div>
    <div class="content">
      <div class="content-box">
        <div class="top">
          <div class="message-title Medium">酒店信息</div>
          <div class="message">
            <div class="message-name">
              <h3 class="Bold">{{ details.HotalName }}</h3>
              <span class="Regular">预订热线：{{ details.TelePhone }}</span>
            </div>
            <p class="Regular" v-html="details.HotalDescirption"></p>
          </div>
          <div class="search-box">
            <div class="search-item">
              <el-date-picker
                v-model="searchData.StartTime"
                type="date"
                @input="handleDateChange"
                placeholder="入住日期 "
                value-format="yyyy-MM-dd"
                :editable="false"
                :picker-options="startOptions"
              >
              </el-date-picker>
            </div>
            <div class="search-item">
              <el-date-picker
                v-model="searchData.EndTime"
                type="date"
                placeholder="离店日期"
                value-format="yyyy-MM-dd"
                :editable="false"
                :picker-options="endOptions"
              >
              </el-date-picker>
            </div>
            <div class="search-item">
              <div class="room-search">
                <p>房间</p>
                <div class="search-inp">
                  <i class="el-icon-remove-outline" @click="reduceNum"></i>
                  <div><el-input v-model="searchData.RoomQty"></el-input></div>
                  <i class="el-icon-circle-plus-outline" @click="addNum"></i>
                </div>
              </div>
            </div>
            <div class="search-btn" @click="getRoomList">查看房型</div>
          </div>
        </div>
        <div class="bottom Regular">
          <p class="room-title Medium">客房列表</p>
          <div class="room-list-header">
            <div style="width: 230px">房型</div>
            <div style="width: 174px">床型</div>
            <div style="width: 234px">政策</div>
            <div style="width: 120px">房间数</div>
            <div style="width: 174px">价格名称</div>
            <div style="width: 120px">价格</div>
            <div style="width: 100px">操作</div>
          </div>
          <div
            class="room-list"
            v-loading="loading"
            element-loading-text="加载中..."
          >
            <div class="room-item" v-for="item in roomList">
              <div class="img">
                <img :src="item.RoomImageUrl" alt="" />
                <span>{{ item.OrderItemCName }}</span>
                <p @click="lookDes(item.CDescribe)">查看入住说明</p>
              </div>
              <div class="room-message" style="flex: 1">
                <div class="room-message-item" v-for="ite in item.RoomsInfos">
                  <div style="width: 174px">{{ ite.OrderItemCName }}</div>
                  <div style="width: 234px">00:00-24:00可住</div>
                  <div style="width: 120px" class="num">
                    剩{{ ite.AvaQty }}间
                  </div>
                  <div style="width: 174px">{{ ite.PriceName }}</div>
                  <div style="width: 120px">
                    <div class="price">
                      <p class="Medium">{{ ite.Aveprice }}</p>
                    </div>
                  </div>
                  <div style="width: 100px">
                    <div
                      class="btn"
                      v-if="
                        ite.CanBooking == '1' &&
                        ite.AvaQty >= searchData.RoomQty
                      "
                      @click="getDetails(ite)"
                    >
                      预订
                    </div>
                    <div
                      class="null"
                      v-else
                      @click="showReason(ite.NoBookingReason)"
                    >
                      无房
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="roomList.length == 0" class="empty">
              暂无房型，请先搜索
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-foot">
      <p>Copy Right © 捷信达技术支持</p>
    </div>
    <el-dialog
      title="确认订单 Confirm Order"
      :visible.sync="dialogTableVisible"
      width="640px"
      @close="closeWin"
    >
      <div
        class="dialog-box"
        v-loading="load"
        element-loading-text="订单确认中..."
      >
        <div class="dialog-top">
          <span class="Medium">房型 Room Type : {{ itemDetails.OrderItemCName }}</span>
          <div class="dialog-message">
            <div>
              <p>入住日期<br/>Arrival Date</p>
              <el-date-picker
                v-model="searchData.StartTime"
                type="date"
                placeholder="入住日期 "
                @input="handleDateChange"
                value-format="yyyy-MM-dd"
                :editable="false"
                :picker-options="startOptions"
              >
              </el-date-picker>
            </div>
            <div>
              <p>离店日期<br/>Departure Date</p>
              <el-date-picker
                v-model="searchData.EndTime"
                type="date"
                placeholder="离店日期"
                value-format="yyyy-MM-dd"
                :editable="false"
                :picker-options="endOptions"
              >
              </el-date-picker>
            </div>
            <div>
              <p>房间数<br/>Rooms</p>
              <div class="search-inp">
                <i class="el-icon-remove-outline" @click="reduceNum"></i>
                <div><el-input v-model="searchData.RoomQty"></el-input></div>
                <i class="el-icon-circle-plus-outline" @click="addNum"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-form">
          <el-form
            ref="form"
            :rules="rules"
            :model="form"
            label-width="180px"
            label-position="left"
          >
            <el-form-item label="预订人 Booker" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入预订人姓名 Please enter the booker"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号 Mobile number" prop="mobile">
              <el-input
                v-model="form.mobile"
                placeholder="请输入预订人手机号 Please enter the booker's mobile number"
              ></el-input>
            </el-form-item>          
            <el-form-item label="信用卡 Credit Card" prop="creditcard">
              <el-input
              v-model="form.creditcard"
                maxlength="30"
                placeholder="请输入信用卡卡号 Please enter the Credit Card number"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱 Email" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="备注 Notes">
              <el-input v-model="form.remark"></el-input>
            </el-form-item>
            <el-form-item label="支付方式 Payment methods">
              <div class="pay">{{this.needPay ? "微信支付 WechatPay" : "到店支付 Pay in hotel"}}</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-bottom">
          <div class="notice">
            <el-radio></el-radio>
            <div class="noticeMsgContainer">
              <div>我已阅读接受<span @click="lookBookNote(booknote)">预订须知</span></div>
              <div>I have read and accepted<span @click="lookBookNote(booknote)">Reservation Notice</span></div>
            </div>
          </div>
          <div class="payment">
            <div class="total">
              <p>总计金额 Total Amount:</p>
              <span class="Medium">{{ totalPrice }}</span>
            </div>
            <div class="payment-btn" @click="goPay()">确认支付 Confirm</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="扫码支付"
      :visible.sync="showCode"
      width="400px"
      top="24vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="coloseCode"
    >
      <div class="wx-code">
        <div id="qrCode" ref="qrCodeDiv"></div>
        <p>微信扫码支付</p>
      </div>
    </el-dialog>
    <el-dialog
      title="入住说明"
      :visible.sync="showDes"
      width="800px"
      top="24vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="coloseCode"
    >
      <div class="wx-code" v-html="des"></div>
    </el-dialog>
    <el-dialog
      title="预订须知"
      :visible.sync="showBookNote"
      width="800px"
      top="24vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="coloseCode"
    >
      <div class="wx-code" v-html="booknote"></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWebSite,
  orderSubmitDetail,
  orderListSearch,
  orderSubmit,
  getMemberOrderList,
  getOrderInfo,
} from "@/request/order.js";
import QRCode from "qrcodejs2";
import { mapGetters, mapState } from "vuex";
var day1 = new Date();
var month =
  day1.getMonth() + 1 < 10 ? "0" + (day1.getMonth() + 1) : day1.getMonth() + 1;
var s1 = day1.getFullYear() + "-" + month + "-" + String(day1.getDate()).padStart(2, '0');
var day3 = new Date();
day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
var month1 =
  day3.getMonth() + 1 < 10 ? "0" + (day3.getMonth() + 1) : day3.getMonth() + 1;
var s3 = day3.getFullYear() + "-" + month1 + "-" + String(day3.getDate()).padStart(2, '0');
export default {
  name: "index",
  data() {
    const validatePhone = (rule, value, callback) => {
      var reg = /^1[34578]\d{9}$/;
      // 手机号
      if (value == "") {
        callback(new Error("请输入预订人手机号"));
      } else {
        callback();
      }
    };
    return {
      searchData: {
        StartTime: s1,
        EndTime: s3,
        RoomQty: "1",
      },
      dialogTableVisible: false,
      showCode: false,
      radio: "1",
      form: {
        name: "",
        mobile: "",
        time: "",
        remark: "",
        creditcard:"",
        email:"",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入预订人姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: validatePhone,
          },
        ],
        creditcard: [
          {
            required: true,
            message: "请输入信用卡号",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: false,
            trigger: "blur",
          },
        ],
      },
      details: {}, // 酒店信息
      roomList: [], // 酒店列表
      loading: false,
      startOptions: null,
      endOptions: null,
      itemDetails: {}, // 单个房间详情
      totalPrice: 0,
      booknote:"",
      checkedRooms: [], //房间详情中每个日期的房间信息
      load: false,
      OrderNo: "", //订单号
      timer: null,
      showDes: false,
      showBookNote:false,
      des: "",
      defaultRoomTypeCode:null,//默认房间类型，由第三方传入，当有值时，则在获取到房间类型列表后，自动弹出该房型的预订框
      needPay:true,//是否需要支付,默认需要支付
      needMember:true,//是否需要会员登录，默认需要会员登录
    };
  },
  // 过滤器
  filters: {
    dateFormat: function (value) {
      if (value) {
        var year = value.substring(0, 4);
        var month = value.substring(5, 7);
        var day = value.substring(8, 10);
        return year + "-" + month + "-" + day;
      } else {
        return "";
      }
    },
  },
  // 局部注册的组件
  components: {},
  // 计算属性
  computed: {
    ...mapGetters("member", ["Token", "ProfileId", "GuestCName"]),
    paymentMethod() {
      return this.needPay ? "wxpay" : "payinhotel";
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 点击跳转到个人中心
    goUser() {
      this.$router.push({
        path: "/user",
      });
    },
    // 生成二维码
    bindQRCode(value) {
      new QRCode(this.$refs.qrCodeDiv, {
        text: value,
        width: 300,
        height: 300,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
    htmlDecodeByRegExp(str){  
            var temp = "";
           if(str.length == 0) return "";
             temp = str.replace(/&amp;/g,"&");
             temp = temp.replace(/&lt;/g,"<");
             temp = temp.replace(/&gt;/g,">");
             temp = temp.replace(/&nbsp;/g," ");
              temp = temp.replace(/&#39;/g,"\'");
             temp = temp.replace(/&quot;/g,"\"");
             temp = temp.replace(/\n/g,"<br/>");
              return temp;  
        },
    // 显示房间入住说明
    lookDes(value) {
      this.showDes = true;
      this.des = this.htmlDecodeByRegExp(value);
    },
    lookBookNote(value) {
      this.showBookNote = true;
      this.booknote = this.htmlDecodeByRegExp(value);
    },
    // 获取房间信息
    roomMessage() {
      getWebSite().then((res) => {
        this.details = res.response;
      });
    },
    // 房间数量减法
    reduceNum() {
      if (this.searchData.RoomQty > 1) {
        this.searchData.RoomQty--;
      } else {
        this.searchData.RoomQty = 1;
      }
    },
    // 房间数量加法
    addNum() {
      this.searchData.RoomQty++;
    },
    // 获取房间列表
    getRoomList() {
      if (this.searchData.StartTime == "") {
        this.$message.error("请选择入住日期");
        return false;
      } else if (this.searchData.EndTime == "") {
        this.$message.error("请选择离店日期");
        return false;
      } else {
        this.searchData.RoomQty = this.searchData.RoomQty.toString();
        this.loading = true;
        orderListSearch(this.searchData).then((res) => {
          if (res.response.Code == 200) {
            this.loading = false;
            this.roomList = res.response.Rooms;
            //如果有默认房间类型，则自动弹出预订框
            if(this.defaultRoomTypeCode){
              let defaultRoomTypeItem = this.roomList.find(item=>item.OrderItemCode == this.defaultRoomTypeCode);
              if(defaultRoomTypeItem){
                this.getDetails(defaultRoomTypeItem.RoomsInfos[0]);
              }
            }
          } else {
            this.$message.error(res.response.Data);
            this.loading = false;
          }
        });
      }
    },
    // 点击不可预订显示原因
    showReason(value) {
      this.$message.error(value ? value : "房间数量不足！");
    },
    // 点击预订显示预订信息
    getDetails(item) {
      this.itemDetails = item;
      var formData = {
        BeginDate: this.searchData.StartTime,
        EndDate: this.searchData.EndTime,
        RoomQty: this.searchData.RoomQty.toString(),
        OrderItemCode: item.OrderItemCode,
        PayType: this.paymentMethod,
        Ratecode: item.Ratecode,
      };
      orderSubmitDetail(formData).then((res) => {
        if (res.response.Code == "200") {
          this.dialogTableVisible = true;
          var total = 0;
          res.response.SubmitDetailS.forEach((item) => {
            total += Number(item.Price);
          });
          this.checkedRooms = res.response.SubmitDetailS;
          this.totalPrice = (total * this.searchData.RoomQty).toFixed(2);
          this.booknote = item.BookingNoticeCdesc;
        } else {
          this.$message.error(res.response.Data);
        }
      });
    },
    // 关闭详情弹窗
    closeWin() {
      this.dialogTableVisible = false;
      this.totalPrice = 0;
      this.booknote = "";
      this.form = {
        name: "",
        mobile: "",
        time: "",
        remark: "",
        creditcard:"",
        email:"",
      };
    },
    // 确认支付
    goPay() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.load = true;
          var orderData = {
            BeginTime: this.searchData.StartTime,
            EndTime: this.searchData.EndTime,
            TotalAmount: this.totalPrice.toString(), //this.totalPrice.toString()
            SalesPromotionId: this.itemDetails.SalePromotionId,
            GuestName: this.form.name,
            GuestMobile: this.form.mobile,
            OrderItemCode: this.itemDetails.OrderItemCode,
            RoomQty: this.searchData.RoomQty.toString(),
            ArriveTime: this.form.time,
            GuestRemark: this.form.remark,
            PayType: this.paymentMethod,
            DetailRoom: this.checkedRooms,
            Email:this.form.email,
          };
          if(this.form.creditcard != null && this.form.creditcard!=""){
            orderData.GuestRemark = orderData.GuestRemark+" 信用卡Credit Card："+this.form.creditcard;
          }
          if (this.needMember && !this.Token){
            this.$confirm("您还未登录请先去登录?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push("/login");
              })
              .catch(() => {});
              return;
          }
          orderSubmit(this.Token, orderData).then((res) => {
            if (res.response.Code == "200") {
              this.load = false;
              this.OrderNo = res.response.SubmitOrderView.OrderNo;
              if(!this.needPay){
                this.$message.info("预订成功");
                this.closeWin();
                return;
              }
              this.showCode = true;
              this.$nextTick(function () {
                // 防止二维码出现多个
                document.getElementById("qrCode").innerHTML = "";
                this.bindQRCode(res.response.SubmitOrderView.Qrcode);
              });
              // 定时查询是否支付完成
              this.timer = setInterval(() => {
                this.isPay();
              }, 3000);
            } else {
              this.$message.error(res.response.Data);
              this.load = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 关闭二维码
    coloseCode() {
      this.showCode = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    // 查询是否支付完成
    isPay() {
      var formData = {
        OrderNo: this.OrderNo,
      };
      getOrderInfo(this.Token, formData).then((res) => {
        if (res.response.GetOrerInfoView.Staues == "1") {
          clearInterval(this.timer);
          // this.$message.success('支付成功，3秒后将自动跳转');
          this.$router.push({
            path: "/win",
            query: { type: 2 },
          });
        }
      });
    },
    // 限制选择开始日期
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      };
    },
    // 限制选择结束日期
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchData.StartTime) {
            return (
              new Date(self.searchData.StartTime).getTime() > time.getTime()
            );
          } else {
            return time.getTime() < Date.now();
          }
        },
      };
    },
    handleDateChange(event) {
      if(this.searchData.StartTime){
        var day = new Date(this.searchData.StartTime);
        day1 = new Date(day.setDate(day.getDate() + 1));
  var month = day1.getMonth() + 1 < 10 ? "0" + (day1.getMonth() + 1) : day1.getMonth() + 1;
  var s1 = day1.getFullYear() + "-" + month + "-" + String(day1.getDate()).padStart(2, '0');
        this.searchData.EndTime = s1;
      }
    }
  },
  beforeCreate() {},
  created() {
    //获取url参数中的默认房间类型
    const urlParams = new URLSearchParams(window.location.search);
    this.defaultRoomTypeCode = urlParams.get('roomTypeCode');
    this.needPay = urlParams.get('needPay') == '0' ? false : true;
    this.needMember = urlParams.get('needMember') == '0' ? false : true;
    this.roomMessage();
    this.getRoomList();
  },
  beforeMount() {},
  mounted() {
    this.startOptions = this.beginDate();
    this.endOptions = this.processDate();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style>
.search-inp > div .el-input__inner {
  border: none;
  box-sizing: border-box;
  color: #000000;
  display: inline-block;
  font-size: inherit;
  height: 38px;
  line-height: 38px;
  outline: 0;
  padding: 0;
  font-size: 14px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  text-align: center;
}
.notice .el-radio {
  margin-right: 0;
}
.el-date-editor.el-input {
  width: 100%;
}
</style>
<style scoped>
.nav {
  width: 100%;
  height: 48px;
  background: #2a82e4;
  position: fixed;
  top: 100px;
  z-index: 999;
}
.nav-list {
  max-width: 1200px;
  height: 48px;
  margin: auto;
  display: flex;
}
.nav-list li {
  width: 148px;
  height: 48px;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active {
  background: #0a56bb;
}

.content {
  min-height: calc(100% - 228px);
  background: #f0f2f5;
  padding-top: 148px;
  display: flex;
  flex-direction: column;
}
.content-box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.top {
  width: 100%;
  box-sizing: border-box;
  padding: 30px 24px 24px 24px;
  background: #fff;
  margin: 24px 0;
}
.message-title {
  font-size: 16px;
  margin-bottom: 24px;
  font-weight: 500;
}
.message {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}
.message-name {
  display: flex;
  align-items: baseline;
  margin-bottom: 16px;
}
.message-name h3 {
  font-size: 24px;
  color: #000;
}
.message-name span {
  font-size: 14px;
  color: #999;
  margin-left: 27px;
}
.message p {
  font-size: 14px;
  line-height: 24px;
}
.search-box {
  width: 100%;
  background: #f0f2f5;
  box-sizing: border-box;
  padding: 24px;
  display: flex;
}
.search-item {
  width: 220px;
  margin-right: 12px;
}
.room-search {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 10px;
}
.room-search p {
  font-size: 14px;
  color: #999;
}
.search-inp {
  display: flex;
  align-items: center;
}
.search-inp i {
  font-size: 24px;
  color: #2a82e4;
  cursor: pointer;
}
.search-inp > div {
  width: 40px;
}
.search-btn {
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  background: #ff9500;
  margin-left: 20px;
  cursor: pointer;
}
.bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px;
  background: #fff;
  flex: 1;
}
.room-title {
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin-bottom: 16px;
}
.room-list-header {
  width: 100%;
  height: 40px;
  display: flex;
  background: #f0f2f5;
  align-items: center;
}
.room-list-header div {
  text-indent: 12px;
}
.room-item {
  width: 100%;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  align-items: center;
}
.img {
  width: 230px;
  display: flex;
  flex-direction: column;
  padding: 24px 0;
}
.img img {
  width: 130px;
  height: 88px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.img span {
  font-size: 18px;
  color: #000;
  margin-bottom: 14px;
}
.img p {
  font-size: 14px;
  color: #2a82e4;
  cursor: pointer;
}
.room-message {
  flex: 1;
}
.room-message-item {
  width: 100%;
  display: flex;
  height: 72px;
  border-bottom: 1px solid #e4e4e4;
  align-items: center;
}
.room-message-item > div {
  text-indent: 12px;
}
.room-message .room-message-item:last-child {
  border-bottom: 0;
}
.num {
  color: #f96868;
}
.btn {
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ff9500;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  cursor: pointer;
}
.null {
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #cccccc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  font-weight: 400;
}
.price {
  color: #499bfc;
  font-size: 16px;
  display: flex;
  align-items: baseline;
  text-indent: 0;
}
.price p {
  font-size: 24px;
  font-weight: 500;
}
.dialog-box {
  width: 100%;
}
.dialog-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 22px;
}
.dialog-top img {
  width: 170px;
  height: 110px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.dialog-top > span {
  font-size: 18px;
  color: #000000;
  margin-bottom: 12px;
}
.dialog-message {
  width: 100%;
  background: #f0f2f5;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 14px 12px;
  display: flex;
  justify-content: space-around;
}
.dialog-message div {
  width: 140px;
  font-size: 14px;
  color: #999999;
  display: flex;
  flex-direction: column;
}
.dialog-message div span {
  color: #000;
  font-size: 16px;
  margin-top: 6px;
}
.dialog-message .search-inp{
  display: flex;
  flex-direction: row;
}
.dialog-message .search-inp div{
  width:100px;
}
.pay {
  width: 200px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #43cf7c;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
}
.dialog-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.notice {
  display: flex;
  font-size: 16px;
  color: #999;
}
.notice > div {
  display: flex;
  align-items: baseline;
}
.notice > div span {
  color: #2a82e4;
  margin-left: 4px;
  cursor: pointer;
}
.noticeMsgContainer{
  display: flex;
  flex-direction: column;
}
.payment {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 24px;
}
.total {
  display: flex;
  align-items: baseline;
  font-size: 14px;
  color: #999999;
}
.total span {
  font-size: 24px;
  color: #ff9500;
}
.payment-btn {
  width: 180px;
  height: 40px;
  background: #2a82e4;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}
.wx-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 24px;
}
.wx-code p {
  margin-top: 30px;
}
.empty {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
.member {
  display: flex;
  font-size: 18px;
  color: #666;
  cursor: pointer;
}
.member p {
  margin-left: 10px;
}
.el-form-item__label {
  white-space: pre-line;
}
</style>